var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account_image",class:{
        'account_image--failed_loading': _vm.showInitial,
    },style:(_vm.imageStyle)},[(_vm.src)?_c('img',{staticClass:"account_image__loader",attrs:{"alt":"Image","src":_vm.src},on:{"error":_vm.onImageLoadError}}):_vm._e(),(_vm.showInitial)?_c('span',[_vm._v(_vm._s(_vm.initial.toUpperCase()))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }